<template>
  <Header />
  <div class="title-container">
    <h1>Assessment Tasks</h1>
    <button class="importCSV-button" @click="navigateToImportAssessmentTasks()">Import Assessment Tasks</button>
  </div>

  <div class="container-fluid-project">
    <vue-good-table :columns="columns" :rows="processedRows" :pagination-options="{
      enabled: true,
      perPage: perPage
    }" :search-options="{ enabled: false }" :sort-options="{
      enabled: true,
    }">
      <template #table-row="props">
        <!-- Projects -->
        <span v-if="props.column.field === 'project_names_display'">
          <div
            v-for="(name, index) in props.row.project_names_display"
            :key="index"
            :title="name"
          >
            {{ name }}
          </div>
        </span>

        <!-- Actions column -->
        <span v-else-if="props.column.field === 'actions'">
          <font-awesome-icon 
            icon="edit" 
            class="edit-icon"
            :title="`Edit Assessment Task`"
            @click="openEditAssessmentTaskModal(props.row.assessment_task_id)" 
          />
          <font-awesome-icon icon="trash-alt" class="delete-icon" :title="`Delete Assessment Task`"
            @click="deleteAssessmentTask(props.row.assessment_task_id)" />
        </span>

        <!-- Default rendering -->
        <span v-else :title="String(props.formattedRow[props.column.field] ?? '')">
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <template #emptystate>
        <div style="text-align: center;">No Assessment Tasks found</div>
      </template>
    </vue-good-table>
  </div>
  <div>
    <button class="back-button" @click="goBack">Back</button>
    <button class="btn btn-primary rounded" id=addlogbookButton @click="openAddAssessmentTasksModal">Add Assessment Task</button>
    <button class="btn btn-primary rounded" id=addlogbookButton @click="viewAssignAssessmentTasks()" style="width: 220px;">Assign Assessment Task(s)</button>
  </div>
  <edit-assessment-task-modal v-if="showEditAssessmentTask" @close="closeEditAssessmentTask"></edit-assessment-task-modal>
  <add-assessment-tasks-modal v-if="showAddAssessmentTask" @close="closeAddAssessmentTask"></add-assessment-tasks-modal>
  <assign-assessment-task-modal v-if="showAssignAssessmentTaskModal" :selectedProjectId="selectedProjectId" @close="closeAssignAssessmentTaskModal"></assign-assessment-task-modal>
</template>
    
<script>
import Header from '../Header.vue';
import axios from 'axios';
import { VueGoodTable } from 'vue-good-table-next';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import EditAssessmentTaskModal from './EditAssessmentTaskModal.vue';
import addAssessmentTasksModal from './addAssessmentTasksModal.vue';
import AssignAssessmentTaskModal from '../projects/AssignAssessmentTaskModal.vue';

export default {
  name: 'ViewAssessmentTasks',
  components: {
    Header,
    VueGoodTable,
    EditAssessmentTaskModal,
    addAssessmentTasksModal,
    AssignAssessmentTaskModal,
  },

  data() {
    return {
      productId: this.$route.params.productId,
      assessment_tasks: [],
      assessment_projects: [],
      projects: [],
      perPage: 10,
      showEditAssessmentTask: false,
      showAddAssessmentTask: false,
      filteredAssessmentTasksLength: 0,
      showAssignAssessmentTaskModal: false,
    };
  },
  computed: {
    columns() {
      return [
        { label: 'ID', field: 'assessment_task_id', sortable: true, thClass: 'vgt-id-column', tdClass: 'vgt-id-column' },
        {
          label: 'ATA',
          field: 'chapt_no',
          sortable: true,
          thClass: 'vgt-id-column',
          tdClass: 'vgt-id-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterDropdownItems: this.uniqueChapters,
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return String(rowValue) === String(filterValue);
            }
          }
        },
        {
          label: 'Task No',
          field: 'task_no',
          sortable: true,
          thClass: 'vgt-id-column',
          tdClass: 'vgt-id-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return String(rowValue || '').toLowerCase().includes(String(filterValue).toLowerCase());
            }
          }
        },
        {
          label: 'Category',
          field: 'category',
          sortable: true,
          thClass: 'vgt-category-column',
          tdClass: 'vgt-category-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterDropdownItems: this.uniqueCategories,
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return String(rowValue) === String(filterValue);
            }
          }
        },
        {
          label: 'Question',
          field: 'question',
          sortable: true,
          thClass: 'vgt-name-column',
          tdClass: 'vgt-name-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return String(rowValue || '').toLowerCase().includes(String(filterValue).toLowerCase());
            }
          }
        },
        {
          label: 'Assessment Type',
          field: 'assessment_type',
          sortable: true,
          thClass: 'vgt-category-column',
          tdClass: 'vgt-category-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterDropdownItems: this.uniqueTypes,
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return String(rowValue) === String(filterValue);
            }
          }
        },
        {
          label: `${this.$labels.project}(s)`,
          field: 'project_names_display',
          sortable: false,
          thClass: 'vgt-email-column',
          tdClass: 'vgt-email-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterDropdownItems: this.uniqueProjectOptions,
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;

              return Array.isArray(rowValue)
                ? rowValue.includes(filterValue)
                : String(rowValue) === String(filterValue);
            }
          }
        },
        { label: 'Actions', field: 'actions', sortable: false, thClass: 'vgt-actions-column', tdClass: 'vgt-actions-column' }
      ];
    },
    uniqueChapters() {
      return [...new Set(this.assessment_tasks.map(t => t.chapt_no).filter(Boolean))];
    },
    uniqueCategories() {
      return [...new Set(this.assessment_tasks.map(t => t.category).filter(Boolean))];
    },
    uniqueTypes() {
      return [...new Set(this.assessment_tasks.map(t => t.assessment_type).filter(Boolean))];
    },
    uniqueProjectOptions() {
      const usedProjectIds = [...new Set(
        this.assessment_projects.map(p => p.project_id).filter(Boolean)
      )];

      return usedProjectIds.map(id => {
        const project = this.projects.find(
          p => String(p.project_id) === String(id)
        );

        const projectName = project ? project.name : `Project ${id}`;

        return {
          value: projectName,
          text: projectName,
        };
      });
    },
    processedRows() {
      return this.assessment_tasks.map(t => {
        const taskProjects = this.assessment_projects.filter(
          p => String(p.assessment_task_id) === String(t.assessment_task_id)
        );

        const projectNames = taskProjects.map(p => {
          const match = this.projects.find(
            proj => String(proj.project_id) === String(p.project_id)
          );
          return match ? match.name : `Project ${p.project_id}`;
        });

        return {
          ...t,
          project_names_display: projectNames,
        };
      });
    },
    taskToProjectsMap() {
      const map = {};
      for (const proj of this.assessment_projects) {
        if (!map[proj.assessment_task_id]) {
          map[proj.assessment_task_id] = [];
        }
        const match = this.projects.find(p => String(p.project_id) === String(proj.project_id));
        map[proj.assessment_task_id].push(match ? match.name : proj.project_id);
      }
      return map;
    },
  },
  methods: {
    async fetchProjects() {
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        let result = await axios.get('/api/projects', { headers });
        this.projects = result.data;
      } catch (error) {
        console.error('An error occurred while fetching projects:', error);
      }
    },
    async fetchAssessmentTasks() {
      try {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      // Fetch all AssessmentTasks
      let result = await axios.get('/api/assessment_tasks', { headers });
      this.assessment_tasks = result.data;

      this.totalPages = Math.ceil(this.assessment_tasks.length / this.perPage);

    } catch (error) {
      console.error('An error occurred while fetching data:', error);
    }
    },
    async fetchAssessmentProjects() {
      try {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      // Fetch all AssessmentTasks
      let result = await axios.get('/api/assessment/projects', { headers });
        this.assessment_projects = result.data.assessment_projects;
        console.log('assessment_projects', this.assessment_projects);

    } catch (error) {
      console.error('An error occurred while fetching data:', error);
    }
    },
    openEditAssessmentTaskModal(assessment_task_id) {
      localStorage.setItem('assessment_task_id', assessment_task_id);
      this.showEditAssessmentTask = true;
    },
    openAddAssessmentTasksModal() {
      this.showAddAssessmentTask = true;
    },
    closeEditAssessmentTask() {
      this.showEditAssessmentTask = false; // Close the modal
      this.fetchAssessmentTasks();
    },
    closeAddAssessmentTask() {
      this.showAddAssessmentTask = false; // Close the modal
      this.fetchAssessmentTasks();
    },
    viewAssignAssessmentTasks() {
      this.showAssignAssessmentTaskModal = true; // Show the modal when the button is clicked
    },
    closeAssignAssessmentTaskModal() {
      this.showAssignAssessmentTaskModal = false; // Close the modal
      this.fetchAssessmentProjects();
    },
    deleteAssessmentTask(assessment_task_id) {
      if (confirm("Are you sure you want to delete this Assessment Task?")) {
        if (confirm("This action will PERMANENTLY delete the Assessment Task from the database. Do you wish to continue?")) {
          // If the user confirms the deletion, send a request to delete the Assessment Task.
          const token = localStorage.getItem('token');
          const headers = { Authorization: `Bearer ${token}` };

          axios
            .delete(`/api/assessment_tasks/${assessment_task_id}`, { headers })
            .then(response => {
              if (response.status === 200) {
                // Remove the deleted assessment_task from the local data
                this.assessment_tasks = this.assessment_tasks.filter(assessment_task => assessment_task.assessment_task_id !== assessment_task_id);

                window.alert('Assessment Task deleted Successfully');
              }
            })
            .catch(error => {
              // Check if the error is due to a foreign key constraint
              if (error.response && error.response.status === 500) {
                const errorMessage = error.response.data.message;
                const isForeignKeyConstraintError = errorMessage.includes('SQLSTATE[23000]') && errorMessage.includes('Integrity constraint violation: 1451');

                if (isForeignKeyConstraintError) {
                  window.alert('This Assessment Task cannot be deleted because it is already associated with a Practical Element.');
                } else {
                  window.alert('An error occurred while deleting the Assessment Task. Please try again.');
                }
              } else {
                console.error('An unexpected error occurred:', error);
                window.alert('An unexpected error occurred. Please try again.');
              }
            });
        }
      }
    },
    goBack() {
      this.$router.push({ name: 'products' });
    },
    navigateToImportAssessmentTasks() {
      this.$router.push({
        name: 'ImportAssessmentTasks'
      });
    },
  },
  async mounted() {
    this.fetchAssessmentTasks();
    this.fetchAssessmentProjects();
    this.fetchProjects();
  },
};
</script>
    
    
<style scoped>
span:hover {
  cursor: pointer;
  color: blue;
}

.container-fluid-project {
  padding-top: 10px;
  width: 98%;
  margin-left: 1%;
  margin-right: 1%;
  display: flex;
  justify-content: center;
}

button.btn#addlogbookButton {
  padding: 10px 10px;
  font-size: 16px;
  width: 220px;
  height: 40px;
  margin-top: 0;
  margin-bottom: 15px;
  margin-right: 40px;
  border: 1px solid rgb(0, 96, 134);
  background: #2952c4;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
  float: right;
}

button.btn#addlogbookButton:hover {
  background-color: #0c1a61;
  transition: transform 0.2s, box-shadow 0.2s;
}


input[type="text"] {
  width: 100%;
  height: 35px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 5px;
  margin-bottom: 1px;
  margin-right: 20px;
}

input[type="text"]#productFilter {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  width: 200px;
  position: absolute;
  right: 210px;
  top: 0px;
}

input[type="text"]#projectFilter {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  width: 200px;
  position: absolute;
  right: 210px;
  top: 41px;
}

.filter-container {
  margin: 20px 0;
  position: absolute;
  width: 200px;
  top: 0px;
  right: 20px;
}

label {
  margin-top: 8px;
}

.current-time-container {
  position: absolute;
  top: 80px;
  right: 140px;

}

.data-table-trainee {
  width: 97%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-collapse: collapse;
  margin: 0 auto; /* Center the table within its container */
  align-items: center;
  margin-bottom: 30px;
}

.data-table-trainee th,
.data-table-trainee td {
  text-align: left;
  /* Align content to the left */
  padding-left: 10px;
}

.data-table-trainee td.center-icons {
  text-align: center;
}

.pagination-container {
  margin-top: 40px;
  margin-bottom: 0;
  display: flex;
  margin-left: 3%;
}

.edit-icon {
  font-size: 16px;
  /* Adjust the size as needed */
  color: #615f5f;
  /* Change the color to your preference */
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
}

.edit-icon:hover {
  color: #2b2a2a;
  /* Change the color to your preference */
  cursor: pointer;
  transform: scale(1.1);
  /* Example transform for scaling on hover */

}

.delete-icon {
  font-size: 16px;
  color: #FF0000;
  /* Red color */
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
  padding-left: 15px;
}

.delete-icon:hover {
  color: #a82222;
  /* Lighter red color on hover */
  cursor: pointer;
  transform: scale(1.1);
  /* Scale the icon on hover */
  /* You can also add a box-shadow or any other styles you prefer */
}

.clear-filter-button {
  position: absolute;
  right: 50px;
  top: 112px;
  width: 120px;
  border-radius: 5px;
  background-color: #dee2e6;
  font-size: 14px;
  height: 30px;
  border: 2px solid black;
  line-height: 0px;
}

.clear-filter-button:hover {
  background-color: #cecece;
  cursor: pointer;
}

.pagination-button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}


.pagination-info {
  font-size: 14px;
  color: #666;
  /* Adjust the color as needed */
  position: absolute;
  top:250px;
  left: 50%;
  /* Center horizontally */
  transform: translateX(-50%);
  /* Center horizontally */
}

.wider-column {
  width: 42%;
}

.td-logbook {
  font-size: 13px;
}


.id-column {
  width: 12%;
}

.info-column {
  width: 17%;
}

.skinny-column {
  width: 5%;
}

.back-button {
  float: left;
  width: 100px;
  margin-left: 40px;
  border-radius: 5px;
  background-color: #c1e0bf;
  font-size: 14px;
  border: 2px solid black;
  padding: 3px;
}

.back-button:hover {
  background-color: #abc7a9;
  cursor: pointer;
}

.title-container {
  margin-top: 20px;
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 3%;
  padding-right: 20px;
}

h1 {
  padding-top: 0px;
}

button#traineeProgressButton {
  border-radius: 5px;
  background-color: #c1f5bb;
  font-size: 13px;
  padding: 3px;
  width: 60px;
  border: 1px solid #366131;
}

button#traineeProgressButton:hover {
  background-color: #8fd192;
  cursor: pointer;
}

.questions-cell {
  white-space: pre-line; /* respects \n, collapses multiple spaces */
}

.importCSV-button {
  margin-left: 0;
  border-radius: 5px;
  min-width: 220px;
  height: 35px;
  background-color: #02092b;
  color: white;
  border: 1px solid #00051d;
  margin-right: 10px;
  padding: 0 10px;
  margin-left: 15px;
}

.importCSV-button:hover {
  background-color: #031363;
  color: white;
  transform: scale(1.05);
  transition: 0.3s;
}
</style>